import React from 'react';

import * as formTypes from 'constants/formTypes';

import i18n from 'util/i18n';

import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP } from 'config/formSections/legal';

import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import OrganizationalItem from './OrganizationalItem';

const sectionConfig = {
  key: LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP.name,
  storeKey: LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP.storeKey,
};

const SubSectionHeader = function ({ subSectionAssetPath }) {
  return (
    <div>
      <h3>{i18n.t(`${subSectionAssetPath}.preambleLabel`)}</h3>
      <p>{i18n.t(`${subSectionAssetPath}.preamble`)}</p>
      <p>{i18n.t(`${subSectionAssetPath}.purpose`)}</p>
      <p>{i18n.t(`${subSectionAssetPath}.terrorPurpose`)}</p>

      <ul>
        <li>
          {i18n.t(`${subSectionAssetPath}.purposeBulletOne`)}
        </li>
        <li>
          {i18n.t(`${subSectionAssetPath}.purposeBulletTwo`)}
        </li>
        <li>
          {i18n.t(`${subSectionAssetPath}.purposeBulletThree`)}
        </li>
      </ul>
      <p>{i18n.t(`${subSectionAssetPath}.definition`)}</p>
    </div>
  );
};

export class TerroristOrganizationMemebrship extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasTerroristOrganizationMembership: this.props.HasTerroristOrganizationMembership,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasTerroristOrganizationMembership: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  render() {
    const { errors } = this.props;
    const subSectionName = 'terroristOrganizationMembership';
    const sectionAssetPath = 'legal.pvq.associations';
    const subSectionAssetPath = `${sectionAssetPath}.${subSectionName}`;
    const subSectionClassName = subSectionAssetPath.replaceAll('.', '-');

    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    const summary = (item, index) => {
      const o = (item && item.Item) || {};
      const dates = DateSummary(o.Dates);
      const details = (o.Organization || {}).value || '';

      return Summary({
        type: i18n.t(`${subSectionAssetPath}.collection.item`),
        index,
        left: details,
        right: dates,
        placeholder: i18n.t(`${subSectionAssetPath}.collection.unknown`),
      });
    };

    return (
      <div
        className={`section-content ${subSectionClassName}`}
        data-section={LEGAL.key}
        data-subsection={LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP.key}
      >
        <h1 className="section-header">
          {i18n.t(`legal.pvq.subsection.associations.${subSectionName}`)}
        </h1>
        <SubSectionHeader subSectionAssetPath={subSectionAssetPath} />
        <Branch
          name="HasTerroristOrganizationMembership"
          label={i18n.t(`${subSectionAssetPath}.hasTerroristOrganizationMembership`)}
          labelSize="h4"
          className={`${subSectionClassName}-HasTerroristOrganizationMembership`}
          {...this.props.HasTerroristOrganizationMembership}
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateBranch}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasTerroristOrganizationMembership"
        />

        <Show when={this.props.HasTerroristOrganizationMembership.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t(`${subSectionAssetPath}.collection.description`)}
            appendTitle={i18n.t(`${subSectionAssetPath}.collection.appendTitle`)}
            appendLabel={i18n.t(`${subSectionAssetPath}.collection.appendLabel`)}
            required={this.props.required}
            attribute="List"
            scrollIntoView={this.props.scrollIntoView}
          >
            <OrganizationalItem
              name="Item"
              attribute="List"
              bind
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              subSectionAssetPath={subSectionAssetPath}
              subSectionClassName={subSectionClassName}
              aware
              intended
              engaged
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

TerroristOrganizationMemebrship.defaultProps = {
  name: 'terrorist-organization-membership',
  HasTerroristOrganizationMembership: {},
  List: EmptyListInstance,
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'associations/terrorist-organization-membership',
  addressBooks: {},
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(TerroristOrganizationMemebrship, sectionConfig);
